import { FormattedMessage, FormattedPlural } from "react-intl";
import Icon from "../../utils/Icon";
import { Fragment } from "react";
import getMessage from "../../utils/getMessage";
import DigiraatiRelativeTime from "../../common/DigiraatiRelativeTime";


const HearingInformationCommentCount = ({
  hearing, 
  justNumber = true,
  dl = false,
}) => {

  const printCommentCountSpan = () => (
    <span className="hearing-card-comment-count">
      {
        justNumber
          ? <>{hearing.n_comments}</>
          : 
          <FormattedPlural 
            value={hearing.n_comments}
            one={<FormattedMessage id="sectionTotalComment" values={{ n: hearing.n_comments }} />}
            other={<FormattedMessage id="sectionTotalComments" values={{ n: hearing.n_comments }} />}
          />
      }
      </span>
  )

  if (dl) {
    return (
      <Fragment>
        <dt>
          <Icon  name="comment-o" aria-hidden="true" title={getMessage("commentCount")}/>
          <span className="sr-only">{getMessage("commentCount")}</span>
        </dt>
        <dd>
          {printCommentCountSpan()}
          {hearing.last_comment_at && 
            <span className="last-comment-at">
              <DigiraatiRelativeTime date={new Date(hearing.last_comment_at)} />
            </span>
          }
        </dd>
      </Fragment>
    )
  }

  return (
    <div style={{display: 'grid', gridTemplateColumns: 'min-content 1fr', alignItems: 'center', gap: '1ch'}}>
      <Icon  name="comment-o" aria-hidden="true"/>
      <span className="hearing-card-comment-count">
        {printCommentCountSpan()}
          {hearing.last_comment_at && 
            <span className="last-comment-at">
              <DigiraatiRelativeTime date={new Date(hearing.last_comment_at)} />
            </span>
          }
      </span>
    </div>
  )
}

export default HearingInformationCommentCount;